import React, { ReactNode } from "react";

import { DynamicLink } from "app/links/DynamicLink/DynamicLink";

import "./style.scss";

export interface SectionHeaderLinkProps {
    title: string;
    url: string;
    rel?: string;
    children?: ReactNode | ReactNode[];
}

export const SectionHeaderLink = ({ title, url, rel }: SectionHeaderLinkProps) => {
    const classNames = ["sectionHeaderLink"];

    return (
        <DynamicLink href={url} className={classNames.join(" ")} rel={rel}>
            {title}
        </DynamicLink>
    );
};
